import { Controller } from "@hotwired/stimulus"
import { jsonFetch } from "../helpers/json_fetch"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.#fetchFollowedNicks().then(({ nicks }) => {
      this.buttonTargets.forEach(button => {
        if (!nicks.includes(button.dataset.followBatchNick)) return

        button.dispatchEvent(new CustomEvent("cults:markAsFollowed"))
      })
    })
  }

  #fetchFollowedNicks() {
    // TODO: prefer a dynamic path
    return jsonFetch("/en/followees", { method: "GET" })
  }
}
